module.exports = __webpack_public_path__ + "img/mer.464abf4.svg";